import { Observation } from "@medplum/fhirtypes";

import { ActionIcon, Menu, rem, Table, Tooltip } from "@mantine/core";

import { IconDotsVertical } from "@tabler/icons-react";

import EditLaborStage from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/EditLaborStage";

interface ActionCellProps extends React.ComponentProps<typeof Table.Td> {
  rowSpan: number;
  observation?: Observation;
}

export default function ActionCell({ rowSpan, ...props }: ActionCellProps) {
  if (!props.observation) return null;

  return (
    <Table.Td
      miw={70}
      ta="center"
      rowSpan={rowSpan}
      style={{
        borderLeft: "1px solid var(--mantine-color-cream-4)",
        width: rem(70),
        minWidth: rem(70),
        maxWidth: rem(70),
      }}
      {...props}
    >
      <Menu withArrow position="bottom">
        <Menu.Target>
          <Tooltip label="Edit Labor Stage" aria-label="Edit Labor Stage">
            <ActionIcon variant="subtle">
              <IconDotsVertical size={20} />
            </ActionIcon>
          </Tooltip>
        </Menu.Target>
        <EditLaborStage currentObservation={props.observation!} />
      </Menu>
    </Table.Td>
  );
}
